import { render } from "./EditOptionImages.vue?vue&type=template&id=2b751760"
import script from "./EditOptionImages.vue?vue&type=script&lang=js"
export * from "./EditOptionImages.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__